import { gql, TypedDocumentNode } from '@apollo/client';
import {
  OvertimeProjectEmployees,
  OvertimeProjectEmployeesVariables,
} from './__generated__/OvertimeProjectEmployees.query';
import EmployeeFragment from './Employee.fragment';

const OvertimeProjectEmployeesQuery: TypedDocumentNode<
  OvertimeProjectEmployees,
  OvertimeProjectEmployeesVariables
> = gql`
  query OvertimeProjectEmployees($projectId: ID!) {
    employeesForProject(id: $projectId) {
      ...Employee
    }
  }

  ${EmployeeFragment}
`;

export default OvertimeProjectEmployeesQuery;
